"use client";

import { loadZendesk } from "@/app/layouts/standard/header/utils/zendeskUtils";
import Button from "@/components/design-system/button";
import { useDispatch } from "react-redux";
import styles from "./searchFeedbackWithChat.module.scss";

export default function ChatWithUsButton() {
  const dispatch = useDispatch();

  const openChat = async () => {
    await loadZendesk(dispatch, true);
  };

  return (
    <Button
      variant="tertiary"
      color="blue"
      size="large"
      text="Chat With Us"
      showLeftIcon={false}
      showRightIcon={false}
      className={styles.chatButton}
      onClick={openChat}
    />
  );
}
